// extracted by mini-css-extract-plugin
export var quillEditor = "_pd-1";
export var variable = "_pd-0";